import textData from '../data/data.json';

export const getCaption = (value, maxScore, language = 'en') => {
    const labels = textData[language].caption

    const captions1 = {
        1: labels.never,
        2: labels.sometimes,
        3: '50/50',
        4: labels.often,
        5: labels.always,
    };
    const captions2 = {
        1: labels.never,
        2: labels.never,
        3: labels.sometimes,
        4: labels.sometimes,
        5: '50/50',
        6: '50/50',
        7: labels.often,
        8: labels.often,
        9: labels.always,
        10: labels.always,
    };

    if (maxScore === 4) {
        return captions1[value + 1];
    } else if (maxScore === 5) {
        return captions1[value];
    } else if (maxScore === 9) {
        return captions2[value + 1];
    } else if (maxScore === 10) {
        return captions2[value];
    }
};
